import { Box, Heading, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { AmlV2MatchCard } from 'components/account/jobs-v2/dropdowns/AML/AmlV2MatchCard';
export const AmlV2Results = ({ risks, title = 'Results', countLabel, before, after, emptyMessage }) => {
    const { tokens } = useContext(ThemeContext).theme;
    const isEmpty = risks.length === 0 && !!emptyMessage;
    return (React.createElement(Box, { display: "flex", flexDirection: "column", marginY: "spacing.large", style: { gap: tokens.spacing.default }, width: "80%" },
        React.createElement(Box, null,
            React.createElement(Box, { alignItems: "baseline", display: "flex", justifyContent: "space-between" },
                React.createElement(Heading, { style: { margin: 0, fontWeight: tokens.text.weight.extraBold }, tag: "h4" }, title),
                !isEmpty && (React.createElement(Text, { style: {
                        fontSize: tokens.text.size.small,
                        fontWeight: tokens.text.weight.semiBold,
                        color: tokens.colors.gray300
                    }, tag: "span" }, countLabel ??
                    `${risks.length} potential ${risks.length === 1 ? 'match' : 'matches'} found`))),
            React.createElement(Text, { style: {
                    marginTop: tokens.spacing.xsmall,
                    marginBottom: tokens.spacing.small,
                    fontSize: tokens.text.size.small,
                    color: tokens.colors.gray300
                } }, "Profiles are matched based on reviewing data points available from the submission and sources. Missing data points from either side may reduce confidence in dismissal of matching profiles.")),
        before,
        isEmpty ? (React.createElement(Text, { style: { fontStyle: 'italic', color: tokens.colors.gray600 } }, emptyMessage)) : (risks.map((risk, index) => (React.createElement(AmlV2MatchCard, { key: index, risk: risk })))),
        after));
};
